export default {
    ACTIVE: {
        code: 'ACTIVE',
        text: 'views.worker.common.active',
    },
    NON_PAYMENT_OF_FEE: {
        code: 'NON_PAYMENT_OF_FEE',
        text: 'views.worker.common.non_payment_of_fee',
    },
    NOT_CERTIFIED: {
        code: 'NOT_CERTIFIED',
        text: 'views.worker.common.not_certified',
    },
    PAUSE: {
        code: 'PAUSE',
        text: 'views.worker.common.pause',
    },
    LEAVE: {
        code: 'LEAVE',
        text: 'views.worker.common.leave',
    },
};
